import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useStaffService } from '../../../../apis/staff/useStaffService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { IStaffPayoutResponse } from 'src/apis/staff/staffPayout.interfaces';

export const getStaffPayoutsKey = 'get-staff-payouts';

type TQueryError = IFHError<{ message: string }>;

export const useStaffPayoutsHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<IStaffPayoutResponse, TQueryError>
): UseQueryResult<IStaffPayoutResponse, TQueryError> => {
  const { getStaffPayouts } = useStaffService();
  const queryKey = [getStaffPayoutsKey, params];

  return useQuery<IStaffPayoutResponse, TQueryError>({
    queryKey,
    queryFn: () => getStaffPayouts(params),
    enabled: true,
    ...options,
  });
};
